var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.452 3.26l-7.697 7.583-3.207-3.159a.92.92 0 00-1.283 0 .886.886 0 000 1.264l3.843 3.786.005.005a.91.91 0 00.642.261.912.912 0 00.642-.261l.005-.005 8.333-8.21a.886.886 0 000-1.263.92.92 0 00-1.283 0z","fillRule":"evenodd"}));
}

Tick.defaultProps = {"width":"16","height":"16"};

module.exports = Tick;

Tick.default = Tick;
